export default __webpack_public_path__ + "static/media/WheelButtonPress.972fd430.mp3";